module.exports = __webpack_public_path__ + "img/btn_menu_statistic.2f65e213.svg";